// Generated by OneAdmin on every deploy — edits here are overwritten.
// Sign-up, plans and minutes for pcakefresh. Switched on and set up in OneAdmin → Subscription Model.
const CONFIG = {"app":"pcakefresh","appName":"pcakefresh","api":"https://anewoiyqrskohxkvbpfr.supabase.co/functions/v1/app-access","version":1};

// ── OneAdmin access ──────────────────────────────────────────────────────────────────────────────
// The subscription inside every app OneAdmin deploys. OneAdmin writes this file into the app's
// repo on each deploy with the CONFIG above; the app's owner decides everything else in OneAdmin
// (Subscription Model → the app), and it takes effect here without a redeploy.
//
//   • Activate Signup off: nothing is shown and nothing is counted.
//   • On: the app asks people to sign up or sign in (an emailed 6-digit code — no password to
//     forget), puts new sign-ups on the app's start plan for its trial, and then on the plan the
//     trial moves them to. An app that has its OWN sign-in keeps it: this waits for that sign-in,
//     then looks the person up by it.
//   • Each plan can be used for a number of days from joining it (Trial's days are the trial).
//     While the app is open and visible it reports a minute of use a minute — time spent, for the
//     owner. When the plan allows no days (or they are up), or a page belongs to a feature the plan
//     does not include, a panel in the app's own colours says so and offers the plans the owner
//     sells, priced for the visitor's country (India, EU or US, from the browser's time zone).
//   • An app that switches screens without changing its address (tabs, menus kept in state) is
//     gated at the control instead: a feature's "pages" may name the button that opens it —
//     "text=Reports|Berichte" (its label, in each language) or a CSS selector — and a click on it
//     shows the same panel instead of opening the feature.
//
// For the app's own code, without importing anything (this file exists only in the deployed repo):
//   window.oneadminAccess.status      the current verdict (plan, limits, features)
//   window.oneadminAccess.can(id)     is this feature in the user's plan?
//   window.oneadminAccess.signOut()   for apps using OneAdmin's sign-in
//   window.oneadminAccess.openPlans()
//   window.oneadminAccess.headers()   { "X-OneAdmin-Access": <session> } for the app's own API calls,
//                                     so its backend can ask OneAdmin (app-access "check") what
//                                     this person may do
//   window.addEventListener("oneadmin-access", (e) => e.detail /* the status */)
// and any element marked data-oneadmin-feature="<feature id>" is hidden when the plan lacks it.
//
// These checks run in the visitor's browser, so they decide what the app SHOWS. An app with a
// backend enforces what it SERVES there, with the app's meter key (OneAdmin → app-meter).
(() => {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (window.__oneadminAccessLoaded) return;
  window.__oneadminAccessLoaded = true;

  const TOKEN_KEY = `oneadmin.access.${CONFIG.app}`;
  const CFG_KEY = `oneadmin.access.cfg.${CONFIG.app}`;
  const OK_KEY = `oneadmin.access.ok.${CONFIG.app}`;
  const PREVIEW_KEY = `oneadmin.access.preview.${CONFIG.app}`;
  const LINKED_KEY = `oneadmin.access.linked.${CONFIG.app}`;
  const ls = {
    get: (k) => { try { return localStorage.getItem(k); } catch { return null; } },
    set: (k, v) => { try { localStorage.setItem(k, v); } catch { /* storage off */ } },
    del: (k) => { try { localStorage.removeItem(k); } catch { /* storage off */ } },
  };
  const ss = {
    get: (k) => { try { return sessionStorage.getItem(k); } catch { return null; } },
    set: (k, v) => { try { sessionStorage.setItem(k, v); } catch { /* storage off */ } },
    del: (k) => { try { sessionStorage.removeItem(k); } catch { /* storage off */ } },
  };

  // ── Language: the app's, if it says; else the browser's ──────────────────────────────────────
  const lang = () => {
    let l = window.oneadminHelpConfig && window.oneadminHelpConfig.lang;
    try { if (typeof l === "function") l = l(); } catch { l = null; }
    if (l === "de" || l === "en") return l;
    try { const s = localStorage.getItem("oneadmin.helpLang"); if (s === "de" || s === "en") return s; } catch { /* storage off */ }
    return /^de\b/i.test(navigator.language || "") ? "de" : "en";
  };
  const L = (en, de) => (lang() === "de" ? de : en);
  const esc = (s) => String(s == null ? "" : s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

  // ── The visitor's country, for prices: IN, US or EU — from the time zone, never looked up ─────
  const region = (() => {
    try {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
      if (/^Asia\/(Kolkata|Calcutta)$/.test(tz)) return "IN";
      if (/^America\//.test(tz) || tz === "Pacific/Honolulu") return "US";
    } catch { /* no Intl */ }
    return "EU";
  })();

  // ── Talking to OneAdmin ────────────────────────────────────────────────────────────────────────
  const api = async (action, body) => {
    try {
      const r = await fetch(CONFIG.api, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ app: CONFIG.app, action, region, ...(body || {}) }),
      });
      const j = await r.json().catch(() => ({ ok: false, error: "Bad answer" }));
      return { ...j, httpStatus: r.status };
    } catch { return { ok: false, offline: true }; }
  };

  // ── State ──────────────────────────────────────────────────────────────────────────────────────
  let cfg = null, token = null, status = null, view = "", email = "", error = "", busy = false, preview = false, notice = "";
  let lastBeat = 0, beatTimer = 0, linkTimer = 0;
  const listeners = new Set();

  const publish = () => {
    access.status = status;
    access.email = status && status.email;
    // Their role in the app, as set on OneAdmin's App Subscribers: "member", "admin" or "superadmin".
    access.role = (status && status.role) || null;
    access.active = !!(cfg && cfg.signup) || preview;
    // Whether OneAdmin's sign-up is on is known from here on: an app that signs people in itself
    // waits for this before choosing between OneAdmin's sign-in and its own.
    access.ready = true;
    for (const fn of listeners) { try { fn(status); } catch { /* the app's own handler */ } }
    try { window.dispatchEvent(new CustomEvent("oneadmin-access", { detail: status })); } catch { /* old browser */ }
  };

  const access = window.oneadminAccess = {
    version: 1, ready: false, active: false, status: null, email: null, role: null,
    can: (id) => !status || !status.features || !(id in status.features) || status.features[id] === true,
    onChange: (fn) => { listeners.add(fn); return () => listeners.delete(fn); },
    signOut: () => {
      ls.del(TOKEN_KEY); ls.del(OK_KEY); token = null; status = null; publish();
      if (cfg && cfg.signup && !cfg.ownSignIn) show("signin");
    },
    openPlans: () => { if (status) show("plans"); },
    ownSignIn: () => !!(cfg && cfg.ownSignIn),
    // The session OneAdmin issued, for the app's backend to check with OneAdmin. Never a secret of
    // the app's: it only ever says what this one person may do.
    headers: () => (token ? { "X-OneAdmin-Access": token } : {}),
  };
  Object.defineProperty(access, "token", { get: () => token, enumerable: true });

  // ── Feature-marked elements ────────────────────────────────────────────────────────────────────
  const featureStyle = document.createElement("style");
  featureStyle.setAttribute("data-oneadmin-access", "");
  const applyFeatures = () => {
    const off = status && status.features ? Object.keys(status.features).filter((k) => status.features[k] === false) : [];
    featureStyle.textContent = off.map((id) => `[data-oneadmin-feature="${String(id).replace(/["\\]/g, "")}"]{display:none!important}`).join("\n");
    if (!featureStyle.isConnected) (document.head || document.documentElement).appendChild(featureStyle);
  };

  // ── Pages that belong to a feature the plan does not include ───────────────────────────────────
  const routeRe = (p) => {
    const s = String(p || "").trim();
    if (!s) return null;
    try {
      return new RegExp("^" + s.replace(/[.+?^${}()|[\]\\]/g, "\\$&").replace(/\*/g, ".*").replace(/:[A-Za-z_][A-Za-z0-9_]*/g, "[^/]+") + "/?$");
    } catch { return null; }
  };
  // A pattern is a page ("/reports", "#/reports") or a control (anything else — see below).
  const isPath = (p) => /^#?!?\//.test(String(p || "").trim());
  const blockedHere = () => {
    if (!status || !Array.isArray(status.blockedRoutes)) return null;
    const paths = [location.pathname];
    if (/^#!?\//.test(location.hash)) paths.push(location.hash.replace(/^#!?/, "").split("?")[0]);
    for (const b of status.blockedRoutes) {
      for (const p of b.patterns || []) {
        if (!isPath(p)) continue;
        const re = routeRe(p);
        if (re && paths.some((x) => re.test(x))) return b;
      }
    }
    return null;
  };
  let routeBlock = null;
  const checkRoute = () => {
    const b = blockedHere();
    // A feature panel opened from a control stays until it is closed; only a gated page replaces it.
    if (view === "feature" && !b) return;
    routeBlock = b;
    if (status && status.allowed !== false) {
      if (routeBlock) show("route");
      else if (view === "route") show("");
    }
  };

  // ── Controls that open a feature the plan does not include ─────────────────────────────────────
  // For apps that never change their address. "text=Reports|Berichte": an element whose label —
  // its text, aria-label or title, with case, punctuation and icons set aside — is one of these,
  // or a short label starting with one ("Export PDF" for "Export"). Anything else is a CSS
  // selector ("#export", "[data-tab=reports]"). The click is stopped before the app sees it.
  const norm = (s) => String(s == null ? "" : s).normalize("NFKC").toLowerCase().replace(/[^\p{L}\p{N}]+/gu, " ").trim();
  const controlFor = (target) => {
    if (!status || !Array.isArray(status.blockedRoutes) || !(target instanceof Element) || target === host) return null;
    for (const b of status.blockedRoutes) {
      for (const raw of b.patterns || []) {
        const p = String(raw || "").trim();
        if (!p || isPath(p)) continue;
        if (/^text=/i.test(p)) {
          const labels = p.slice(5).split("|").map(norm).filter(Boolean);
          let el = target;
          for (let i = 0; el && el !== document.body && i < 6; i++, el = el.parentElement) {
            const own = el.innerText || el.textContent || "";
            const names = [el.getAttribute("aria-label"), el.getAttribute("title"), own.length <= 80 ? own : ""].map(norm).filter(Boolean);
            if (names.some((n) => labels.some((l) => n === l || (n.startsWith(l + " ") && n.length <= l.length + 20)))) return b;
          }
        } else {
          try { if (target.closest(p)) return b; } catch { /* not a selector */ }
        }
      }
    }
    return null;
  };
  document.addEventListener("click", (e) => {
    const b = status && status.allowed !== false ? controlFor(e.target) : null;
    if (!b) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    routeBlock = b; show("feature");
  }, true);
  for (const m of ["pushState", "replaceState"]) {
    const orig = history[m];
    if (typeof orig !== "function") continue;
    history[m] = function (...args) { const r = orig.apply(this, args); setTimeout(checkRoute, 0); return r; };
  }
  window.addEventListener("popstate", () => setTimeout(checkRoute, 0));
  window.addEventListener("hashchange", () => setTimeout(checkRoute, 0));

  // ── Shadow DOM ─────────────────────────────────────────────────────────────────────────────────
  const host = document.createElement("div");
  host.id = "oneadmin-access";
  const root = host.attachShadow({ mode: "open" });
  const CSS = `
    :host { all: initial; }
    * { box-sizing: border-box; font-family: var(--font, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif); }
    .wall { position: fixed; inset: 0; z-index: 2147483600; display: flex; align-items: center; justify-content: center;
      padding: 16px; background: var(--wall); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); overflow: auto; }
    .card { background: var(--bg); color: var(--fg); width: min(420px, 100%); border-radius: calc(var(--radius) + 6px);
      padding: 22px; box-shadow: 0 20px 60px rgba(0,0,0,.35); font-size: 14px; line-height: 1.5; display: flex; flex-direction: column; gap: 12px; }
    .app { font-size: 12px; font-weight: 800; letter-spacing: .06em; text-transform: uppercase; color: var(--sub); }
    h1 { font-size: 20px; margin: 0; font-weight: 800; line-height: 1.25; }
    p { margin: 0; color: var(--sub); }
    input { width: 100%; padding: 12px 14px; border-radius: var(--radius); border: 1px solid var(--line); background: var(--card);
      color: var(--fg); font-size: 16px; outline: none; }
    input:focus { border-color: var(--accent); }
    input.code { letter-spacing: .5em; text-align: center; font-size: 22px; font-weight: 800; }
    .big { width: 100%; border: none; border-radius: var(--radius); padding: 12px 14px; cursor: pointer; font-weight: 800; font-size: 15px;
      background: var(--accent); color: var(--accent-fg); }
    .big:disabled { opacity: .55; cursor: default; }
    .link { background: none; border: none; color: var(--link); cursor: pointer; font-size: 13px; padding: 0; text-decoration: underline; }
    .row { display: flex; gap: 14px; flex-wrap: wrap; align-items: center; }
    .err { color: #e5484d; font-size: 13px; font-weight: 600; }
    .ok { color: var(--sub); font-size: 13px; }
    .plans { display: flex; flex-direction: column; gap: 8px; }
    .plan { background: var(--card); border-radius: var(--radius); padding: 12px 14px; display: flex; gap: 10px; align-items: center; }
    .plan .n { font-weight: 800; }
    .plan .d { color: var(--sub); font-size: 12px; }
    .plan ul { margin: 4px 0 0; padding-left: 16px; color: var(--sub); font-size: 12px; }
    .plan .grow { flex: 1; min-width: 0; }
    .small { border: 1px solid var(--line); border-radius: calc(var(--radius) - 2px); padding: 8px 12px; cursor: pointer;
      font-weight: 700; font-size: 13px; background: var(--bg); color: var(--fg); white-space: nowrap; }
    .small.primary { background: var(--accent); color: var(--accent-fg); border-color: var(--accent); }
    .meter { height: 6px; background: var(--card); border-radius: 3px; overflow: hidden; }
    .meter > i { display: block; height: 100%; background: var(--accent); }
    .banner { position: fixed; left: 50%; top: 8px; transform: translateX(-50%); z-index: 2147483601; background: var(--fg); color: var(--bg);
      border-radius: 999px; padding: 6px 8px 6px 14px; font-size: 12px; font-weight: 700; display: flex; gap: 10px; align-items: center;
      box-shadow: 0 6px 20px rgba(0,0,0,.3); }
    .banner button { border: none; border-radius: 999px; padding: 4px 10px; font-weight: 800; cursor: pointer; background: var(--bg); color: var(--fg); font-size: 12px; }
    .toast { position: fixed; left: 50%; bottom: 22px; transform: translateX(-50%); z-index: 2147483602; background: var(--fg);
      color: var(--bg); padding: 8px 14px; border-radius: var(--radius); font-weight: 600; font-size: 13px; }`;
  try { const sheet = new CSSStyleSheet(); sheet.replaceSync(CSS); root.adoptedStyleSheets = [sheet]; }
  catch { const s = document.createElement("style"); s.textContent = CSS; root.appendChild(s); }
  const layer = document.createElement("div");
  root.appendChild(layer);

  // ── The app's theme (the same reading the help panel does) ─────────────────────────────────────
  const px = document.createElement("canvas"); px.width = px.height = 1;
  const pctx = px.getContext("2d", { willReadFrequently: true });
  const rgba = (color) => {
    if (!pctx || !color || (window.CSS && CSS.supports && !CSS.supports("color", color))) return null;
    pctx.clearRect(0, 0, 1, 1); pctx.fillStyle = "#000"; pctx.fillStyle = color; pctx.fillRect(0, 0, 1, 1);
    const d = pctx.getImageData(0, 0, 1, 1).data;
    return { r: d[0], g: d[1], b: d[2], a: d[3] / 255 };
  };
  const css = (c, a = 1) => `rgba(${c.r},${c.g},${c.b},${a})`;
  const lum = (c) => { const f = (v) => { v /= 255; return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4; }; return 0.2126 * f(c.r) + 0.7152 * f(c.g) + 0.0722 * f(c.b); };
  const contrast = (a, b) => { const x = lum(a), y = lum(b); return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05); };
  const mix = (a, b, t) => ({ r: Math.round(a.r + (b.r - a.r) * t), g: Math.round(a.g + (b.g - a.g) * t), b: Math.round(a.b + (b.b - a.b) * t), a: 1 });
  const sat = (c) => { const mx = Math.max(c.r, c.g, c.b), mn = Math.min(c.r, c.g, c.b); return mx ? (mx - mn) / mx : 0; };
  const solidBg = (el) => {
    for (let e = el; e; e = e.parentElement) { const c = rgba(getComputedStyle(e).backgroundColor); if (c && c.a > 0.5) return c; }
    return { r: 255, g: 255, b: 255, a: 1 };
  };
  const readTheme = () => {
    if (!document.body) return;
    const bodyCs = getComputedStyle(document.body);
    const bg = solidBg(document.body);
    let fg = rgba(bodyCs.color) || (lum(bg) < 0.4 ? { r: 240, g: 240, b: 245, a: 1 } : { r: 25, g: 22, b: 35, a: 1 });
    if (contrast(fg, bg) < 3) fg = lum(bg) < 0.4 ? { r: 240, g: 240, b: 245, a: 1 } : { r: 25, g: 22, b: 35, a: 1 };
    let accent = null;
    const rootCs = getComputedStyle(document.documentElement);
    for (const v of ["--accent", "--primary", "--color-primary", "--brand", "--color-accent", "--theme-color"]) {
      const c = rgba(rootCs.getPropertyValue(v).trim());
      if (c && c.a > 0.5 && sat(c) > 0.2) { accent = c; break; }
    }
    if (!accent) { const meta = document.querySelector('meta[name="theme-color"]'); const c = meta && rgba(meta.getAttribute("content")); if (c && c.a > 0.5 && sat(c) > 0.25) accent = c; }
    if (!accent) {
      let best = null, bestSat = 0.3;
      for (const b of Array.from(document.querySelectorAll("button,[role=button],a")).slice(0, 80)) {
        const c = rgba(getComputedStyle(b).backgroundColor);
        if (c && c.a > 0.5 && sat(c) > bestSat) { best = c; bestSat = sat(c); }
      }
      accent = best;
    }
    if (!accent || contrast(accent, bg) < 1.4) accent = lum(bg) < 0.4 ? { r: 167, g: 139, b: 250, a: 1 } : { r: 109, g: 76, b: 230, a: 1 };
    const accentFg = contrast({ r: 255, g: 255, b: 255, a: 1 }, accent) >= contrast({ r: 20, g: 20, b: 20, a: 1 }, accent) ? "#ffffff" : "#141414";
    let radius = 12;
    const ctl = document.querySelector("button,[role=button],input");
    if (ctl) { const r = parseFloat(getComputedStyle(ctl).borderTopLeftRadius); if (!isNaN(r)) radius = Math.max(4, Math.min(18, r || 4)); }
    const vars = {
      "--bg": css(bg), "--fg": css(fg), "--card": css(mix(bg, fg, lum(bg) < 0.4 ? 0.08 : 0.05)),
      "--line": css(mix(bg, fg, 0.18)), "--sub": css(fg, 0.7), "--accent": css(accent), "--accent-fg": accentFg,
      "--link": css(contrast(accent, bg) >= 3 ? accent : fg), "--radius": `${radius}px`, "--font": bodyCs.fontFamily,
      "--wall": css(bg, 0.94),
    };
    for (const [k, v] of Object.entries(vars)) host.style.setProperty(k, v);
  };

  // ── Views ──────────────────────────────────────────────────────────────────────────────────────
  const appName = () => (cfg && cfg.appName) || CONFIG.appName || "";
  const planCards = () => {
    const list = (status && status.plans || []).filter((p) => p.sellable && !p.current);
    if (!list.length) return "";
    return `<div class="plans">${list.map((p) => `<div class="plan"><div class="grow">
        <div class="n">${esc(p.name)}${p.price && p.price !== "0" ? ` · ${esc(status.currency || "")} ${esc(p.price)}${p.period && p.period !== "once" ? ` / ${esc(p.period === "year" ? L("year", "Jahr") : L("month", "Monat"))}` : ""}` : ""}</div>
        ${p.label ? `<div class="d">${esc(p.label)}</div>` : ""}
        ${p.features && p.features.length ? `<ul>${p.features.slice(0, 5).map((f) => `<li>${esc(f)}</li>`).join("")}</ul>` : ""}
      </div><button type="button" class="small primary" data-buy="${esc(p.id)}">${esc(L("Choose", "Wählen"))}</button></div>`).join("")}</div>`;
  };
  /** "N days left": of the trial while on trial, else of the plan's usage days. Nothing when it has no end. */
  const daysLine = () => {
    if (!status || status.daysLeft === null || status.daysLeft === undefined) return "";
    const n = status.daysLeft;
    if (status.state === "trial") return `<p>${esc(L(`Trial: ${n} day${n === 1 ? "" : "s"} left`, `Testphase: noch ${n} Tag${n === 1 ? "" : "e"}`))}</p>`;
    const total = status.usageDays;
    const pct = total ? Math.min(100, Math.round(((total - n) / total) * 100)) : 100;
    return `<div><p>${esc(L(`${n} day${n === 1 ? "" : "s"} left on ${status.plan ? status.plan.name : "your plan"}`, `Noch ${n} Tag${n === 1 ? "" : "e"} mit ${status.plan ? status.plan.name : "deinem Plan"}`))}</p>${total ? `<div class="meter"><i style="width:${pct}%"></i></div>` : ""}</div>`;
  };
  const signOutLink = () => cfg && !cfg.ownSignIn && token && !preview ? `<button type="button" class="link" data-act="signout">${esc(L("Sign out", "Abmelden"))}</button>` : "";

  const render = () => {
    readTheme();
    const parts = [];
    // A quiet preview is a help video being recorded: nothing of OneAdmin's belongs in the picture.
    if (preview && status && status.plan && !status.quiet) {
      parts.push(`<div class="banner">${esc(L(`Previewing as ${status.plan.name} — only you see this`, `Vorschau als ${status.plan.name} — nur für dich sichtbar`))}<button type="button" data-act="endpreview">${esc(L("Exit", "Beenden"))}</button></div>`);
    }
    if (notice) parts.push(`<div class="toast">${esc(notice)}</div>`);
    const card = (inner) => parts.push(`<div class="wall" role="dialog" aria-modal="true"><div class="card"><div class="app">${esc(appName())}</div>${inner}</div></div>`);
    const err = error ? `<div class="err" role="alert">${esc(error)}</div>` : "";
    if (view === "signin") {
      card(`<h1>${esc(L("Sign up or sign in", "Registrieren oder anmelden"))}</h1>
        <p>${esc(L(`Enter your email and we'll send you a code.${cfg && Number(cfg.trialDays) > 0 ? ` New here? Your ${cfg.trialDays}-day trial starts right away.` : ""}`, `Gib deine E-Mail ein, wir schicken dir einen Code.${cfg && Number(cfg.trialDays) > 0 ? ` Neu hier? Deine ${cfg.trialDays}-tägige Testphase beginnt sofort.` : ""}`))}</p>
        <form data-form="email"><input type="email" name="email" autocomplete="email" required placeholder="${esc(L("you@example.com", "du@beispiel.de"))}" value="${esc(email)}"></form>
        ${err}<button type="button" class="big" data-act="send" ${busy ? "disabled" : ""}>${esc(busy ? L("Sending…", "Wird gesendet…") : L("Send code", "Code senden"))}</button>`);
    } else if (view === "code") {
      card(`<h1>${esc(L("Check your email", "Schau in dein Postfach"))}</h1>
        <p>${esc(L(`We sent a 6-digit code to ${email}.`, `Wir haben einen 6-stelligen Code an ${email} geschickt.`))}</p>
        <form data-form="code"><input class="code" name="code" inputmode="numeric" autocomplete="one-time-code" maxlength="6" required placeholder="••••••"></form>
        ${err}<button type="button" class="big" data-act="verify" ${busy ? "disabled" : ""}>${esc(busy ? L("Checking…", "Wird geprüft…") : L("Continue", "Weiter"))}</button>
        <div class="row"><button type="button" class="link" data-act="resend">${esc(L("Send again", "Erneut senden"))}</button>
        <button type="button" class="link" data-act="change">${esc(L("Use a different email", "Andere E-Mail verwenden"))}</button></div>`);
    } else if (view === "blocked" && status) {
      const planName = status.plan ? status.plan.name : "";
      const title = status.reason === "blocked" ? L("Your access is paused", "Dein Zugang ist pausiert")
        : status.reason === "used-up" ? L(`Your ${status.usageDays || ""} days on ${planName || "this plan"} are up`, `Deine ${status.usageDays || ""} Tage mit ${planName || "diesem Plan"} sind vorbei`)
        : status.reason === "no-plan" ? L("There's no plan for you yet", "Für dich gibt es noch keinen Plan")
        : L(`${planName || L("Your plan", "Dein Plan")} doesn't include ${appName()} yet`, `${planName || "Dein Plan"} enthält ${appName()} noch nicht`);
      const sub = status.reason === "blocked" ? L("Contact the app's owner to get it back.", "Wende dich an den Betreiber der App.") : "";
      card(`<h1>${esc(title)}</h1>${sub ? `<p>${esc(sub)}</p>` : ""}
        ${status.reason !== "blocked" && status.plans && status.plans.some((p) => p.sellable && !p.current) ? `<p>${esc(L("Choose a plan to continue:", "Wähle einen Plan, um weiterzumachen:"))}</p>${planCards()}` : ""}
        ${err}<div class="row">${signOutLink()}${preview ? "" : `<button type="button" class="link" data-act="refresh">${esc(L("Check again", "Erneut prüfen"))}</button>`}</div>`);
    } else if ((view === "route" || view === "feature") && status && routeBlock) {
      card(`<h1>${esc(L(`${routeBlock.label || routeBlock.feature} isn't in ${status.plan ? status.plan.name : "your plan"}`, `${routeBlock.label || routeBlock.feature} ist nicht in ${status.plan ? status.plan.name : "deinem Plan"} enthalten`))}</h1>
        ${planCards()}${err}
        <div class="row">${view === "route"
          ? `<button type="button" class="small" data-act="back">${esc(L("Go back", "Zurück"))}</button>`
          : `<button type="button" class="small" data-act="close">${esc(L("Close", "Schließen"))}</button>`}</div>`);
    } else if (view === "offline") {
      card(`<h1>${esc(L("Can't reach the sign-in service", "Der Anmeldedienst ist nicht erreichbar"))}</h1>
        <p>${esc(L("Check your connection and try again.", "Prüfe deine Verbindung und versuche es erneut."))}</p>
        <button type="button" class="big" data-act="refresh">${esc(L("Try again", "Erneut versuchen"))}</button>`);
    } else if (view === "plans" && status) {
      card(`<h1>${esc(status.plan ? status.plan.name : L("Plans", "Pläne"))}</h1>
        ${daysLine()}${planCards()}${err}
        <div class="row"><button type="button" class="small" data-act="close">${esc(L("Close", "Schließen"))}</button>${signOutLink()}</div>`);
    }
    layer.innerHTML = parts.join("");
    // While a panel stands in front of the app, the page behind it does not scroll. The app's own
    // inline overflow is put back exactly as it was.
    const lock = view === "signin" || view === "code" || view === "blocked" || view === "offline"
      || ((view === "route" || view === "feature") && !!routeBlock);
    const de = document.documentElement;
    if (lock && !de.dataset.oneadminLocked) { de.dataset.oneadminLocked = de.style.overflow || "-"; de.style.overflow = "hidden"; }
    else if (!lock && de.dataset.oneadminLocked) { const prev = de.dataset.oneadminLocked; de.style.overflow = prev === "-" ? "" : prev; delete de.dataset.oneadminLocked; }
    const first = layer.querySelector("input");
    if (first && (view === "signin" || view === "code")) setTimeout(() => first.focus(), 0);
  };
  const show = (v) => { view = v; error = ""; render(); };

  // ── Actions ────────────────────────────────────────────────────────────────────────────────────
  const setStatus = (st) => {
    const openFeature = view === "feature" && routeBlock ? routeBlock.feature : "";
    status = st;
    if (status && status.allowed) ls.set(OK_KEY, String(Date.now()));
    applyFeatures();
    routeBlock = blockedHere();
    if (!status) { publish(); return; }
    // A feature panel opened from a control stays open while that feature is still not included.
    const still = openFeature && Array.isArray(status.blockedRoutes) ? status.blockedRoutes.find((b) => b.feature === openFeature) : null;
    if (!routeBlock && still) routeBlock = still;
    const gated = routeBlock ? (still && routeBlock === still ? "feature" : "route") : "";
    if (preview) { view = status.allowed === false ? "blocked" : gated; render(); publish(); return; }
    if (status.allowed === false) view = "blocked";
    else if (gated) view = gated;
    else if (view === "blocked" || view === "route" || view === "feature" || view === "signin" || view === "code" || view === "offline") view = "";
    render(); publish();
    // Minutes are counted from the moment the app may be used — also when that happens later than
    // sign-in (time added by the owner, a plan bought, "Check again").
    if (status.allowed && token) startBeats();
  };
  const signedOut = () => {
    ls.del(TOKEN_KEY); ls.del(OK_KEY); token = null; status = null; applyFeatures(); publish();
    if (cfg && cfg.signup && !cfg.ownSignIn) show("signin"); else show("");
  };
  const handle = (r) => {
    if (r && r.token) { token = r.token; if (!preview) ls.set(TOKEN_KEY, r.token); }
    if (r && r.ok && r.status) setStatus(r.status);
    else if (r && r.signedOut) signedOut();
    return r;
  };
  const refresh = async () => {
    if (!token) return;
    const r = await api("status", { token });
    if (r.offline) {
      // Can't reach OneAdmin. Someone let in recently stays in; nobody new is let in on a guess.
      const okAt = Number(ls.get(OK_KEY) || 0);
      if (Date.now() - okAt > 86_400_000) show("offline");
      return;
    }
    handle(r);
  };
  const beat = async () => {
    if (!token || preview || !status || !status.allowed || document.visibilityState !== "visible") return;
    // The first beat comes 5 seconds in and the next on the minute, 55 seconds later: the guard sits
    // below that (and the server's own 50 seconds) so no minute is skipped, only true repeats.
    if (Date.now() - lastBeat < 45_000) return;
    lastBeat = Date.now();
    handle(await api("beat", { token }));
  };

  const send = async () => {
    const input = layer.querySelector('input[name="email"]');
    email = String(input ? input.value : email).trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { error = L("That doesn't look like an email address.", "Das sieht nicht nach einer E-Mail-Adresse aus."); render(); return; }
    busy = true; error = ""; render();
    const r = await api("send-code", { email });
    busy = false;
    if (r.ok) { view = "code"; render(); }
    else { error = r.offline ? L("No connection.", "Keine Verbindung.") : (r.error || L("Couldn't send the code.", "Der Code konnte nicht gesendet werden.")); render(); }
  };
  const verify = async () => {
    const input = layer.querySelector('input[name="code"]');
    const code = String(input ? input.value : "").replace(/\D/g, "");
    if (code.length !== 6) { error = L("Enter the 6-digit code.", "Gib den 6-stelligen Code ein."); render(); return; }
    busy = true; error = ""; render();
    const r = await api("verify-code", { email, code });
    busy = false;
    if (r.ok) handle(r);
    else { error = r.offline ? L("No connection.", "Keine Verbindung.") : (r.error || L("That code isn't right.", "Der Code ist nicht richtig.")); render(); }
  };
  const buy = async (planId) => {
    if (preview) { error = L("Plans can't be bought in a preview.", "In der Vorschau kann nichts gekauft werden."); render(); return; }
    busy = true; error = ""; render();
    const r = await api("checkout", { token, plan: planId, returnUrl: location.origin + location.pathname });
    busy = false;
    if (r.ok && r.url) { location.href = r.url; return; }
    error = r.error || L("Payments aren't available right now.", "Zahlungen sind gerade nicht möglich."); render();
  };

  layer.addEventListener("click", (e) => {
    const t = e.target instanceof Element ? e.target.closest("[data-act],[data-buy]") : null;
    if (!t) return;
    if (t.dataset.buy) { buy(t.dataset.buy); return; }
    const act = t.dataset.act;
    if (act === "send" || act === "resend") send();
    else if (act === "verify") verify();
    else if (act === "change") { view = "signin"; error = ""; render(); }
    else if (act === "signout") access.signOut();
    else if (act === "refresh") refresh();
    else if (act === "close") show("");
    else if (act === "back") { if (history.length > 1) history.back(); else location.assign("/"); }
    else if (act === "endpreview") { ss.del(PREVIEW_KEY); location.reload(); }
  });
  layer.addEventListener("submit", (e) => {
    e.preventDefault();
    const f = e.target instanceof Element ? e.target.getAttribute("data-form") : "";
    if (f === "email") send(); else if (f === "code") verify();
  });

  const startBeats = () => {
    if (beatTimer || preview) return;
    beatTimer = setInterval(beat, 60_000);
    setTimeout(beat, 5_000);
    document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") { refresh(); } });
  };

  // ── An app with its own sign-in (Supabase): look the person up by the app's session ───────────
  const appSession = () => {
    try {
      for (let i = 0; i < localStorage.length; i++) {
        const k = localStorage.key(i);
        const m = k && /^sb-([a-z0-9]+)-auth-token$/.exec(k);
        if (!m) continue;
        const v = JSON.parse(localStorage.getItem(k) || "null");
        const s = v && (v.currentSession || v);
        if (s && s.access_token) return { url: `https://${m[1]}.supabase.co`, accessToken: s.access_token, userId: s.user && s.user.id };
      }
    } catch { /* storage off */ }
    return null;
  };
  const watchAppSession = () => {
    // A session OneAdmin turned down is not offered again; the next one (a new sign-in, a refreshed
    // token) is.
    let refused = "";
    const tick = async () => {
      const s = appSession();
      if (!s) { if (token) signedOut(); return; }
      if (token && ls.get(LINKED_KEY) === (s.userId || "")) return;
      if (s.accessToken === refused) return;
      const r = await api("link", { url: s.url, accessToken: s.accessToken });
      if (r.ok) { ls.set(LINKED_KEY, s.userId || ""); handle(r); }
      else if (!r.offline) refused = s.accessToken;
    };
    tick();
    linkTimer = setInterval(tick, 3000);
    window.addEventListener("storage", tick);
  };

  // ── Coming back from a checkout ────────────────────────────────────────────────────────────────
  const paidReturn = () => {
    try {
      const u = new URL(location.href);
      const paid = u.searchParams.get("oneadmin_paid");
      if (!paid) return;
      u.searchParams.delete("oneadmin_paid");
      history.replaceState(history.state, "", u.pathname + (u.search ? u.search : "") + u.hash);
      if (paid === "cancelled") return;
      notice = L("Thank you — your plan is being updated.", "Danke — dein Plan wird aktualisiert.");
      let n = 0;
      const poll = setInterval(async () => { n++; await refresh(); if (n >= 6 || (status && status.plan && status.plan.id === paid)) { clearInterval(poll); notice = ""; render(); } }, 2500);
    } catch { /* no URL API */ }
  };

  // ── Start ──────────────────────────────────────────────────────────────────────────────────────
  const start = async () => {
    document.body.appendChild(host);
    // Preview links from OneAdmin carry a token in the hash: "#oneadmin-preview=…". Kept for this
    // tab only, and taken out of the address so a shared link never carries it.
    const m = /[#&]oneadmin-preview=([A-Za-z0-9_.-]+)/.exec(location.hash || "");
    if (m) {
      ss.set(PREVIEW_KEY, m[1]);
      const rest = location.hash.replace(/[#&]?oneadmin-preview=[A-Za-z0-9_.-]+/, "").replace(/^#?&/, "#");
      history.replaceState(history.state, "", location.pathname + location.search + (rest && rest !== "#" ? rest : ""));
    }
    const pv = ss.get(PREVIEW_KEY);

    const cached = (() => { try { const c = JSON.parse(ls.get(CFG_KEY) || "null"); return c && Date.now() - c.at < 300_000 ? c.cfg : null; } catch { return null; } })();
    if (cached) cfg = cached;
    else {
      const r = await api("config");
      if (r.ok) { cfg = r; ls.set(CFG_KEY, JSON.stringify({ at: Date.now(), cfg: r })); }
      else if (!r.offline) cfg = { signup: false };
      else { try { cfg = (JSON.parse(ls.get(CFG_KEY) || "null") || {}).cfg || null; } catch { cfg = null; } }
    }
    if (pv) {
      preview = true; token = pv;
      const r = await api("status", { token });
      if (r.ok) { handle(r); return; }
      ss.del(PREVIEW_KEY); preview = false; token = null;
    }
    if (!cfg || !cfg.signup) { publish(); return; }
    paidReturn();
    if (cfg.ownSignIn) { publish(); watchAppSession(); return; }
    token = ls.get(TOKEN_KEY);
    if (!token) { show("signin"); publish(); return; }
    await refresh();
  };
  if (document.body) start(); else document.addEventListener("DOMContentLoaded", start, { once: true });
})();
